// extracted by mini-css-extract-plugin
module.exports = {"heading":"experts_heading__TnGn4","content":"experts_content__ftR4N","button":"experts_button__3yvZC","sending":"experts_sending__2Mfs7"};